const increaseImg = (imgBlockSelector) => {
    const imgBlock = document.querySelector(imgBlockSelector);

    try {
        imgBlock.addEventListener('click', (e) => {
            let target = e.target;

            if(target.classList.contains('img')) {
                let divModal = document.createElement('div');
                divModal.classList.add('modal-wrap');

                document.body.append(divModal);
                addEventListener('keydown', closeEsc);

                divModal.innerHTML = `<div class="modal slide-up-long img-popup-wrap">
                        <div class="close-modal"></div>
                    <div class="modal-content">
                        <img src="${target.src}" class="img">
                    </div>
                </div>`;

                divModal.addEventListener('click', (event)=>{
                    let targetModal = event.target;

                    if(targetModal.classList.contains('modal-wrap') || targetModal.classList.contains('close-modal')) {
                        divModal.remove();
                        removeEventListener('keydown', closeEsc);
                    }
                });
            }
        });
    } catch(e){}

    function closeEsc(e) {
		if(e.keyCode === 27) {
            if(document.querySelector('.modal-wrap')) {
                document.querySelector('.modal-wrap').remove();
            }
            
			removeEventListener('keydown', closeEsc);
		}
	}
};

export default increaseImg;